let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jDjSj")).then(() => parcelRequire('d4cCP'));